import { render, staticRenderFns } from "./WalletCardPlaceholder.vue?vue&type=template&id=a9a72310&scoped=true&"
import script from "./WalletCardPlaceholder.vue?vue&type=script&lang=js&"
export * from "./WalletCardPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardPlaceholder.vue?vue&type=style&index=0&id=a9a72310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a72310",
  null
  
)

export default component.exports